module.exports = __webpack_public_path__ + "img/share.a2f79e6e.svg";